var _title, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "org-add")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4,13V9.67a7.14,7.14,0,1,0-14.28,0V13A7.14,7.14,0,1,0,26.4,13Zm-2.2,0a4.95,4.95,0,1,1-9.89,0V9.67a4.95,4.95,0,1,1,9.89,0ZM14.8,24.86H17a1.11,1.11,0,0,0,1.09-1.11h0A1.1,1.1,0,0,0,17,22.65H14.8A9.88,9.88,0,0,0,5,32.59V37a1.09,1.09,0,0,0,1.09,1.1H17A1.09,1.09,0,0,0,18.07,37h0A1.09,1.09,0,0,0,17,35.91H7.16V32.59A7.68,7.68,0,0,1,14.8,24.86Zm13.38-2.21A7.73,7.73,0,0,0,28,38.11h.2a7.73,7.73,0,0,0,0-15.46Zm0,13.26a5.53,5.53,0,1,1,5.52-5.53A5.53,5.53,0,0,1,28.18,35.91Z",
    fill: "#737476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.18,34.71a1,1,0,0,1-1-1V27.05a1,1,0,0,1,2,0v6.66A1,1,0,0,1,28.18,34.71Z",
    fill: "#737476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.51,31.38H24.85a1,1,0,0,1,0-2h6.66a1,1,0,0,1,0,2Z",
    fill: "#737476"
  })));
}

export default SvgOrgAdd;